import { styled } from '@mui/material';

/**
 * The inset accent glow. The 2.4s breathe always runs but is paused, and plays while `data-breathe` is set, so
 * switching off freezes it where it is while the layer fades out instead of snapping back to full opacity.
 */
export const GlowBreathe = styled('span')({
  position: 'absolute',
  inset: 0,
  borderRadius: 'inherit',
  boxShadow: 'inset 0 0 48px 4px color-mix(in oklab, var(--background-accent) 22%, transparent)',
  '@keyframes formsGlowBreathe': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.55 },
  },
  animation: 'formsGlowBreathe 2.4s ease-in-out infinite paused',
  '&[data-breathe]': {
    animationPlayState: 'running',
  },
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none !important',
  },
});
